import 'ress';
import 'core-js/stable';
import '../scss/style.scss';
import './scrollnav';
import common from './common/index';

common();
